import script from "./ServiceView.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceView.vue?vue&type=script&setup=true&lang=js"

import "./ServiceView.vue?vue&type=style&index=0&id=d6d1fd08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6d1fd08"]])

export default __exports__